<span (click)="logout()">{{ label || 'Log out'}}</span>
